/* This is generated code, don't alter */
var IfcPileConstructionEnum;
(function (IfcPileConstructionEnum) {
    IfcPileConstructionEnum[IfcPileConstructionEnum["CAST_IN_PLACE"] = 0] = "CAST_IN_PLACE";
    IfcPileConstructionEnum[IfcPileConstructionEnum["COMPOSITE"] = 1] = "COMPOSITE";
    IfcPileConstructionEnum[IfcPileConstructionEnum["PRECAST_CONCRETE"] = 2] = "PRECAST_CONCRETE";
    IfcPileConstructionEnum[IfcPileConstructionEnum["PREFAB_STEEL"] = 3] = "PREFAB_STEEL";
    IfcPileConstructionEnum[IfcPileConstructionEnum["USERDEFINED"] = 4] = "USERDEFINED";
    IfcPileConstructionEnum[IfcPileConstructionEnum["NOTDEFINED"] = 5] = "NOTDEFINED";
})(IfcPileConstructionEnum || (IfcPileConstructionEnum = {}));
const IfcPileConstructionEnumCount = 6;
export { IfcPileConstructionEnum, IfcPileConstructionEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcPileConstructionEnum = new Int32Array([27]);
let prefixSumAddressIfcPileConstructionEnum = new Uint32Array([0, 11, 23, 41, 55, 68, 83]);
let slotMapIfcPileConstructionEnum = new Int32Array([1, 5, 2, 3, 4, 0]);
let encodedDataIfcPileConstructionEnum = (new TextEncoder()).encode(".COMPOSITE..NOTDEFINED..PRECAST_CONCRETE..PREFAB_STEEL..USERDEFINED..CAST_IN_PLACE.");
let IfcPileConstructionEnumSearch = new MinimalPerfectHash(gMapIfcPileConstructionEnum, prefixSumAddressIfcPileConstructionEnum, slotMapIfcPileConstructionEnum, encodedDataIfcPileConstructionEnum);
export { IfcPileConstructionEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcPileConstructionEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcPileConstructionEnumSearch, input, cursor, endCursor);
}
